import { createContext, useContext, useState } from "react";

export const ROLES = {
  USER: "user",
  ESTUDIANTE: "estudiante",
  CONSULTOR: "consultor",
  CREADOR: "creador",
  ADMIN: "admin",
  SUPERADMIN: "superadmin",
  SOPORTE: "soporte",
};

export const ROLE_META = {
  user: { label: "Usuario", color: "#3C78B5", glyph: "U" },
  estudiante: { label: "Estudiante", color: "#1FA774", glyph: "E" },
  consultor: { label: "Consultor", color: "#A855F7", glyph: "C" },
  creador: { label: "Creador", color: "#A67C00", glyph: "✦" },
  admin: { label: "Administrador", color: "#7A0E17", glyph: "A" },
  superadmin: { label: "Director KD9", color: "#D4AF37", glyph: "★" },
  soporte: { label: "Soporte KD9", color: "#0E7A4D", glyph: "S" },
};

const RoleContext = createContext({
  role: "user",
  setRole: () => {},
});

export const RoleProvider = ({ children }) => {
  // Presentation adapter only. AuthContext derives this role exclusively from
  // GET /api/me/access-map; permissions and flags never live in RoleContext.
  const [role, setRoleState] = useState("user");
  const setRole = (nextRole) => setRoleState(nextRole || "user");

  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
